import { motion, Variants, MotionProps } from 'framer-motion'
import { ElementType, useMemo } from 'react'
import { fadeUp } from '@/utils/animations'

interface MotionWrapperProps extends MotionProps {
  children: React.ReactNode
  className?: string
  variants?: Variants
  once?: boolean
  to?: string
  as?: ElementType
  initial?: string
  animate?: string
  alwaysVisible?: boolean
  onClick?: (e: React.MouseEvent) => void
}

const Motion: React.FC<MotionWrapperProps> = ({
  children,
  className,
  variants = fadeUp,
  once = false,
  to,
  as: Tag = 'div',
  initial,
  animate,
  alwaysVisible = false,
  style,
  ...rest
}) => {
  const MotionTag = useMemo(() => {
    if (typeof Tag === 'string') {
      return (
        (motion as unknown as Record<string, typeof motion.div>)[Tag] ||
        motion.div
      )
    }
    // For custom components, fall back to motion.div
    return motion.div
  }, [Tag])

  const shouldUseViewport = !animate && !alwaysVisible

  const motionProps = {
    ...(to ? { to } : {}),
  }

  return (
    <MotionTag
      {...motionProps}
      className={className}
      variants={variants}
      initial={initial || 'hidden'}
      whileInView={!alwaysVisible ? animate || 'visible' : undefined}
      animate={alwaysVisible ? animate || 'visible' : undefined}
      viewport={shouldUseViewport ? { once, amount: 0.2 } : undefined}
      style={{
        overflow: 'hidden',
        ...style,
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  )
}

export default Motion
